<div class="d-inline-block">
    <div class="badge badge-outline-danger d-flex align-items-center" style="margin-top: -5px">
        <fa-icon [icon]="['far', 'pause-circle']"></fa-icon>
        <span class="ml-1">On Hold</span>
    </div>
</div>
